var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['piece', ("piece-" + (_vm.$props.colour || 'none')), _vm.$props.small ? 'piece-small' : '']})}
var staticRenderFns = []

export { render, staticRenderFns }